import { Mailbox } from 'components'
import { useCurrentProving } from 'hooks/useCurrentProving'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Page, Section } from './Layout'

export const PageMails: React.FC = () => {
  const { t } = useTranslation()
  const [proving] = useCurrentProving()

  return (
    <Page>
      <Section label={t('section.mails.header')}>
        <Mailbox proving={proving} />
      </Section>

      {/* <Section label={t('section.debug.header')}>
        <pre>{JSON.stringify(proving, null, 2)}</pre>
      </Section> */}
    </Page>
  )
}
